<template>
    <div>
        <a-input size="small" :style="option.showDirect ? 'width:60%' : 'width:100%'" v-model="systemName" :id="option.id ? option.id : 'orgInput'" placeholder="请选择系统" readonly></a-input>
        <a-checkbox v-if="option.showDirect" v-model="option.directFlag" style="padding-left:5px" @change="directChange">{{$t('global.currentOrg')}}</a-checkbox>
        <ul id="treeDiv" class="ztree" style="min-width:200px;background-color: #f9f9f9;border: 1px solid #ccc;margin-top:5px" v-show="isSelectOrg" v-bind:class="{absoluteTree: !option.isRelative }">
            <a-input v-if="orgData.children" ref="searchInput" autofocus :placeholder="$t('global.inputFliterTip')" v-model="searchInput" style="margin-bottom:8px"></a-input>
            <z-org-chooser-item :treeData="orgData"  @selectNode="onSelectNode"></z-org-chooser-item>
        </ul>
    </div>
</template>

<script>
    import ZOrgChooserItem from './OrgChooserItem.vue'
    import config from '@/config'
    import lodash from 'lodash'

    export default {
        name: "ZOrgChooser",
        props: ["option"],
        components: {
            ZOrgChooserItem
        },
        data: function () {
            return {
                systemName: '',
                orgData:'',
                isSelectOrg: false,
                searchInput: '',
                tempObj: null,
                selectedId: null
            }
        },
        watch: {
            searchInput: function () {
                this.filterOrg()
            }
        },
        created() {
            this.initOrgTree()
        },
        methods: {
            getFilterOrg() {
                if (this.searchInput.length > 0){
                    this.orgData = JSON.parse(this.tempObj)
                    this.filterNode(this.orgData)
                    this.setSelectNode(this.orgData,this.selectedId)
                }else{
                    this.orgData = JSON.parse(this.tempObj)
                    this.setSelectNode(this.orgData,this.selectedId)
                }
            },
            filterNode(data){
                let filtered = true;
                if(data.children){
                    for(var i = 0 ; i < data.children.length ; i++){
                        if(data.children[i].children && data.children[i].children.length > 0){
                            if(!this.filterNode(data.children[i]) && data.children[i].name.indexOf(this.searchInput) == -1){
                                data.children.splice(i,1)
                                i --;
                            }
                        }else {
                            if(data.children[i].name.indexOf(this.searchInput) == -1) {
                                data.children.splice(i,1)
                                i --;
                            }
                        }
                    }
                    if(data.children.length == 0){
                        filtered = false;
                    }

                    for(var j = 0 ; j < data.children.length ; j++){
                        if(j == data.children.length - 1){
                            data.children[j].isLastNode = true
                        }else{
                            data.children[j].isLastNode = false
                        }
                    }
                }
                return filtered;
            },
            showOrgTree(){
                this.isSelectOrg = true;
            },
            initOrgTree(data,selectNodeId) {
                if(data){
                    this.orgData = data
                    this.tempObj = JSON.stringify(this.orgData)
                    this.setTree(selectNodeId)
                    this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                }else{
                    this.$http.get(config.api.org_tree_url).then((response) => {
                        this.orgData = response.result
                        this.tempObj = JSON.stringify(this.orgData)
                        this.setTree(selectNodeId)
                        this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                var that = this;

                function ready(fn) {
                    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
                        fn();
                    } else {
                        document.addEventListener('DOMContentLoaded', fn);
                    }
                }

                ready(function(){
                    document.body.addEventListener('mousedown', function(event){
                        let element = event.target
                        let isOrgInput = false;
                        let isTreeDiv = false;
                        while(element){
                            if(that.option.id){
                                if(element.id == that.option.id){
                                    isOrgInput = true
                                }
                            }else if(element.id == 'orgInput'){
                                isOrgInput = true
                            }

                            if(element.id == 'treeDiv'){
                                isTreeDiv = true
                            }
                            element = element.parentElement || element.parentNode || null
                        }
                        if(isOrgInput){
                            that.isSelectOrg = true;
                        }else{
                            if(!isTreeDiv){
                                that.isSelectOrg = false;
                            }
                            if(event.target.id == 'cancelUpdate'){
                                that.$emit('closeUpdateOrgModel');
                            }
                        }
                    });
                });
            },
            setTree(selectNodeId){
                this.selectedId = selectNodeId ? selectNodeId :this.orgData.id
                let selectedNode = this.getNodeById(this.orgData,this.selectedId)
                this.onSelectNode(selectedNode)
            },

            getNodeById(data,nodeId){
                if(data.id == nodeId){
                    return data
                }
                if(data.children != null){
                    for(var i = 0 ; i < data.children.length ; i ++){
                         let node = this.getNodeById(data.children[i],nodeId);
                         if(node){
                             return node;
                         }
                    }
                }
                return null;
            },

            getSelectNodeId(node){
                let _this = this
                if(node.isSelected == true){
                    return node.id;
                }
                if(node.children != null){
                    for(var i = 0 ; i < node.children.length ; i ++){
                        let nodeId =  _this.getSelectNodeId(node.children[i]);
                        if(nodeId){
                            return nodeId;
                        }
                    }
                }
                return null;
            },

            setSelectNode(node,selectNodeId){
                if(node.id === selectNodeId){
                    node.isSelected = true;
                }else{
                    node.isSelected = false;
                }

                //TO DO 此处值改变后页面未重新渲染，暂未找到解决办法
                var temp = node.name;
                node.name = '';
                node.name = temp;

                var that = this
                if(node.children != null && node.children.length > 0){
                    node.children.map(function(item){
                        that.setSelectNode(item,selectNodeId);
                    })
                }
            },
            directChange(){
                this.$emit("directChange", this.option.directFlag)
            },
            onSelectNode(node){
                this.setSelectNode(this.orgData,node.id);
                this.selectedId = node.id
                this.isSelectOrg = false
                this.option.value = node.link
                this.option.name = node.name
                this.option.orgId = node.id
                this.systemName = node.name
                this.$emit("orgSelect",node)
            }
        }
    }
</script>


<style lang="less" scoped>
@import '../../theme/page.less';
.absoluteTree{
    position: absolute;
    z-index: 100;
    .liner-gradient-body;
}
.ztree {
    max-height: 75vh;
    overflow-y: auto;
}
</style>
